"use client";

/**
 * Entrega a foto no tamanho certo para cada tela (srcset), sem servidor de
 * imagens: o build gera cópias menores das fotos de public/images com
 * scripts/gerar-imagens.mjs (mesmas larguras de LARGURAS_GERADAS).
 * Para pedidos maiores que a maior cópia, vai o arquivo original.
 * Logos, fotos da equipe e demais imagens passam sem alteração.
 */
const LARGURAS_GERADAS = [480, 640, 768];
const FOTO = /^\/images\/[^/]+\.webp$/;

export default function imageLoader({ src, width }: { src: string; width: number; quality?: number }) {
  if (!FOTO.test(src)) return src;
  const largura = LARGURAS_GERADAS.find((l) => l >= width);
  return largura ? src.replace(/\.webp$/, `-${largura}.webp`) : src;
}
